import { RootState } from '@/shared/types/state';

export const isConfettiActive = (state: RootState): boolean => {
  return state.confetti.enabled;
};
